import { render, staticRenderFns } from "./regrasdeagendamento.vue?vue&type=template&id=4646ac62"
import script from "./regrasdeagendamento.vue?vue&type=script&lang=js"
export * from "./regrasdeagendamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports